import makeStyles from '@mui/styles/makeStyles';

const styles = (theme) => ({

    spinnerSpace: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        flexDirection: 'column !important',
    },

    spinnerText: {
        marginTop: '8px',
        fontSize: '14px',
    },

    spinner: {
        [theme.breakpoints.down('xs')]: {
            height: '60px',
        },
        
        [theme.breakpoints.up('xs')]: {
            maxWidth: '100px',
        },
    },
});

export default styles;
export const useStyles = makeStyles(styles);
